export const dangerColor = '#FA4C4F'
export const warningColor = '#FAAD16'
export const successColor = '#52C41C'
export const textColor = '#777777'
export const homeBg = 'rgb(0, 141, 83, 0.03)' //baseado no primary
export const borderColor = '#DDDDDD'
export const extraColor = '#4285F4'
export const offColor = '#F7F7F7'
export const hiredColor = '#000000'
export const outOfDateColor = '#c402ff'
export const shadowColor = 'rgba(0, 0, 0, 0.2)'
export const outOfRange = '#faae16'

export const metadataInfo = {
  title: "Quero-Quero - Checking the mídia",
  applicationName: 'Quero-Quero Anunciante',
  referrer: 'origin-when-cross-origin',
  creator: 'Create by Audiency',
  description: 'Checking de mídia',
  icons: {
    icon: '/icone.png'
  }
}

export const defaultThemeColors = {
  name: 'queroQuero',
  primary: '#008d53',
  secondary: '#1db954',
  alertInfo: 'rgba(58,170,53, 0.2)',
  background: '#FFFFFF',
  background2: '#f5f5f5 ',
  background3: 'rgba(58,170,53, 0.06)',
  text: '#465A65',
  border: '#E1E1E1',
  headerBg: '#273443',
  disabled: '#CCC',
  scrollbar: 'rgba(87, 71, 143, 0.3)',
  maskModalColor: 'rgba(58,170,53, 0.9)', //baseado no primary
  endOfContractAlert: 'rgb(250, 173, 22, 0.15)',
  newPendingContractAlert: 'rgb(250, 76, 79, 0.1)',
  activeContractAlert: 'rgb(58,170,53, 0.1)'
}

// Cores achadas no site da Quero Quero
// #008d53 - Verde escuro
// #f5f5f5 - Cinza de fundo
// #1db954 - Verde claro
// #b30d14 - Frete texto
// #f7e800 - Frete Tag
